import { Mountain, Sprout } from "lucide-react";

export const AREAS = [
  { slug: "territorio", name: "Territorio", icon: Mountain, color: "#2E4F3B",
    desc: "Prendersi cura del Monte Faeta significa intervenire prima che l'abbandono diventi un problema. Recuperiamo uliveti e aree degradate per un territorio più curato e resiliente." },
  { slug: "agricoltura-ambiente", name: "Agricoltura & Ambiente", icon: Sprout, color: "#6B8E3F",
    desc: "Agricoltura e tutela ambientale possono diventare parti dello stesso progetto: soluzioni che mantengano il territorio produttivo, vivo e sostenibile." },
];

export const areaBySlug = (slug) => AREAS.find((a) => a.slug === slug) || AREAS[0];

export const STATUS_LABELS = {
  idea: "Idea",
  in_progettazione: "In progettazione",
  progetto_pilota: "Progetto pilota",
  attivo: "Attivo",
};

export const BADGE_LABELS = {
  idea: "Idea",
  in_progettazione: "In progettazione",
  progetto_pilota: "Progetto pilota",
  attivo: "Attivo",
  cerchiamo_partner: "Cerchiamo partner",
  cerchiamo_sponsor: "Cerchiamo sponsor",
  cerchiamo_volontari: "Cerchiamo volontari",
};

export const isSeeking = (b) => b.startsWith("cerchiamo_");

export function getClientId() {
  let id = localStorage.getItem("pa_client_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random();
    localStorage.setItem("pa_client_id", id);
  }
  return id;
}

export const CONTACT_TYPES = [
  ["cittadino", "Cittadino"], ["volontario", "Volontario"], ["azienda", "Azienda"],
  ["professionista", "Professionista"], ["universita", "Università / Ricerca"],
  ["associazione", "Associazione"], ["ente", "Ente / Fondazione"], ["altro", "Altro"],
];

export const REASONS = [
  ["donazione", "Voglio fare una donazione"], ["sponsor", "Voglio sponsorizzare il progetto"],
  ["partner", "Voglio diventare partner"], ["volontario", "Voglio partecipare come volontario"],
  ["competenze", "Posso offrire competenze"], ["materiali", "Posso offrire materiali/attrezzature"],
  ["proposta", "Ho una proposta"], ["altro", "Altro"],
];
